import { render, staticRenderFns } from "./similarityAnalysisAlt.vue?vue&type=template&id=64da4122&scoped=true"
import script from "./similarityAnalysisAlt.vue?vue&type=script&lang=js"
export * from "./similarityAnalysisAlt.vue?vue&type=script&lang=js"
import style0 from "./similarityAnalysisAlt.vue?vue&type=style&index=0&id=64da4122&prod&lang=scss&scoped=true"
import style1 from "./similarityAnalysisAlt.vue?vue&type=style&index=1&id=64da4122&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da4122",
  null
  
)

export default component.exports